import { Subscription, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

const typeIsArray = <T>() =>
    (x: any): x is T => Array.isArray(x)

interface Options{
  showLoadAtStart: boolean;
}

export class ConsultRequest<T>{
  constructor(
    private options: Options = {
      showLoadAtStart: false
    }
  ){
  }

  private resource: T = null;

  subscription: Subscription;
  private cancelRequest = new Subject<void>();

  get isLoading(): boolean{
    return !!this.subscription && !this.subscription.closed || (!this.subscription && this.options.showLoadAtStart);
  }

  get hasLoadedSomeTime(): boolean{
    return !!this.subscription
  }

  get data(): T {
    if(!this.resource && typeof this.resource != 'number' && typeIsArray<T>()){
      return [] as any as T;
    }

    return this.resource;
  }

  set data(resource: T){
    this.resource = resource;
  }

  get(observable: Observable<T>, successCallback?: ()=>void, errorCallback?: ()=>void){
    this.reset()

    this.subscription = observable
      .pipe(takeUntil(this.cancelRequest))
      .subscribe(
        _data => {
          this.resource = _data
          successCallback && successCallback()
        },
        error => {
          console.log(error);
          errorCallback && errorCallback();
        },
      );

    return this.subscription;
  }

  cancel(){
    this.cancelRequest.next();
  }

  reset(){
    this.resource = null;
    this.cancel();
  }
}
